import { updateProfileAction } from '../update'
import { PROFILES_ACTION } from '../../constants'
import { PROFILE_KEY } from '../../../../../models/profile/constants'

export function updateGoalProfileAction (value) {
  return updateProfileAction({
    type: PROFILES_ACTION.UPDATE_GOAL,
    payload: {
      key: PROFILE_KEY.GOAL,
      value
    }
  })
}
